import { DisplayUser } from '../models/user';

export class SetUser {
    static readonly type = '[Auth] Set User';
    constructor(public user: DisplayUser | null) { }
}
